import {MilestoneDescription} from '@github-ui/item-picker-milestone/components/MilestoneDescription'
import type {MilestonePickerMilestone} from '@github-ui/item-picker-milestone-relay'
import {noop} from '@github-ui/noop'
import {ActionList} from '@primer/react'

import {TEST_IDS} from '../../constants/test-ids'
import styles from './Milestone.module.css'
import {ProgressIcon} from './ProgressIcon'

type MilestoneProps = {
  milestone?: MilestonePickerMilestone | null
  anchorProps?: React.HTMLAttributes<HTMLElement>
}

export function Milestone({milestone, anchorProps}: MilestoneProps) {
  return (
    <>
      {milestone ? (
        <ActionList.LinkItem
          href={milestone.url || '#'}
          target="_blank"
          key={milestone.id}
          data-testid={TEST_IDS.milestoneContainer}
          {...anchorProps}
          onClick={noop}
        >
          <ActionList.LeadingVisual>
            <ProgressIcon progress={milestone.progressPercentage / 100} />
          </ActionList.LeadingVisual>
          {milestone.title}
          <ActionList.Description variant="block">
            <MilestoneDescription
              closed={milestone.closed}
              closedAt={milestone.closedAt}
              progressPercentage={milestone.progressPercentage}
              dueOn={milestone.dueOn}
              showProgressPercentage
            />
          </ActionList.Description>
        </ActionList.LinkItem>
      ) : (
        <div className={styles.hiddenPlaceholder} {...anchorProps} />
      )}
    </>
  )
}

try{ Milestone.displayName ||= 'Milestone' } catch {}